import React, { useEffect, useState } from 'react';
import './Product.css';
import Loading from '../../components/Loading/Loading';
import CartManager from '../../components/Cart/CartManager';
import { Helmet } from 'react-helmet';
import Search from '../../components/Search/Search';
import Map from '../../components/Map/Map';
import Dimensions from '../../components/Dimensions/Dimensions';
import config from '../../../../config';
import SmallCard from '../../components/SmallCard/SmallCard';
/*import LightBoxImage from './LightBoxImage';
*/
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const Product = ({ props }) => {
    const [productLat, setProductLat] = useState();
    const [productLng, setProductLng] = useState();
    const [currentImage, setCurrentImage] = useState("/pimgHD/" + props.pid + "/" + props.data.container_photo_id + ".webp")
    const [bgPos, setBGPos] = useState({ backgroundPosition: '0% 0%', backgroundImage: `url(${currentImage})` })
    const [locationName, setProductLocationName] = useState("Loading...");
    const [products, setProducts] = useState("Loading...");
    const [notFoundProducts, setNotFoundProducts] = useState("Loading...");
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [ready, setReady] = useState(false);
    const [cart, setCart] = useState([]);

    function setProductLocation(locationName) {

        const locations = {
            "Hemmant": [-27.428797, 153.134073],
            "Toowoomba": [-27.554290, 151.909914],
            "Lismore": [-28.816145, 153.259054],
            "Cairns": [-16.873632, 145.735345],
            "Townsville": [-19.239923, 146.669060],
            "Mackay": [-21.096634, 149.044887],
            "Mt Isa": [-20.697122, 139.503711],
            "Rockhampton": [-23.324979, 150.498595],
            "Emerald": [-23.529982, 148.155630],
            "Gladstone": [-23.842224, 151.263291],
            "Childers": [-25.247445, 152.326165],
            "Gympie": [-26.198242, 152.651231],
            "Chinchilla": [-26.804859, 150.729396],
            "Millmerran": [-27.878379, 151.269295],
            "Warwick": [-28.194989, 152.047100],
            "Yatala": [-27.762816, 153.219018]
        };

        for (const key in locations) {
            if (props.productSuccess && locationName.includes(key)) {
                setProductLocationName(key);
                setProductLat(locations[key][0]);
                setProductLng(locations[key][1]);
                break; // exit the loop once a match is found
            }
        }
    }



    function addToCart(props2) {
        CartManager.add({ product_id: props2.pid, quantity: 1, unit_price: props2.price_ex, total_price: props2.price_ex, img: props2.img, title: props2.title, cart_id: CartManager.getCartId() });
    }

    function removeFromCart(pid) {
        CartManager.removeFromCart(pid, 1);
    }

    const [isInCart, setIsInCart] = useState(false);

    useEffect(() => {
        setProductLocation(JSON.stringify(props.data.sale_points));

        CartManager.getCartItemsFull().then(rescart => {
            setCart(rescart);
        });

        CartManager.isInCart(props.pid).then((res) => {
            setIsInCart(res);
        });

        window.addEventListener('storage', storageEventHandler, false);

        async function storageEventHandler(e) {

            CartManager.getCartItemsFull().then(rescart => {
                setCart(rescart);
            });

            CartManager.isInCart(props.pid).then((res) => {
                setIsInCart(res);
            });
        }
    }, [props.pid]);

    const handleMouseMove = (e) => {
        const { left, top, width, height } = e.target.getBoundingClientRect()
        const x = (e.pageX - left) / width * 100
        const y = (e.pageY - top) / height * 100
        setBGPos({ backgroundPosition: `${x}% ${y}%`, backgroundImage: `url(${currentImage})` })
    }

    // function getLocationLink(locationName) {
    //     if (locationName === "Toowoomba") {
    //         return <a href="/toowoomba" className='underline'>Shipping Container For Sale Toowoomba</a>
    //     }
    //     if (locationName === "Hemmant") {
    //         return <a href="/brisbane" className='underline'>Shipping Container For Sale Brisbane (Hemmant)</a>
    //     }
    //     if (locationName === "Lismore") {
    //         return <a href="/lismore" className='underline'>Shipping Container For Sale Lismore</a>
    //     }
    //     if (locationName === "Lismore") {
    //         return <a href="/lismore" className='underline'>Shipping Container For Sale Gympie</a>
    //     }
    //     return "Shipping Container For Sale In " + locationName;
    // }

    return (
        <div>
            <div>
                { props.productSuccess &&
                <div className='Product w-90 mt-5 d-flex row'>
                    <Helmet>
                        <meta name="description" content={props.data.container_short_description} />
                        <title>{props.data.container_iso_description + " " + props.data.container_number}</title>
                        <link rel="canonical" href={`https://${config.domain}/shipping-container/${props.location}/${props.data.container_id}`} />
                    </Helmet>
                    <div className="flex-7 d-flex ProductImages col">
                        <div className="flex-6">
                            <figure className='figure w-100 rounded shadow desktop-no-max-height desktop pointer' onMouseLeave={() => setBGPos({ backgroundPosition: `${0}% ${0}%`, backgroundImage: `none` })} onMouseMove={handleMouseMove} style={bgPos} onClick={() => { lightboxOpen ? setLightboxOpen(false) : setLightboxOpen(true) }}>
                                <img src={currentImage} alt="" className='MainProductImage rounded' />
                            </figure>
                            <img src={currentImage} alt="" className='MainProductImage rounded w-100 rounded shadow mobile mobileProductImage' onClick={() => { lightboxOpen ? setLightboxOpen(false) : setLightboxOpen(true) }} />
                        </div>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <div className='mobile' style={{width: "80vw", overflowX: "scroll"}}>
                            <div className="d-flex space-between MobileProductImagePreviews scrollbar">
                                <img src={`/pimgHD/` + props.pid + "/" + props.data.container_photo_id + ".webp"} onClick={() => {
                                    setCurrentImage("/pimgHD/" + props.pid + "/" + props.data.container_photo_id + ".webp");
                                    setBGPos({ ...bgPos, backgroundImage: `url(${"/pimgHD/" + props.pid + "/" + props.data.container_photo_id + ".webp"})` });
                                }} alt="Container product image." className={`pointer ProductImageSmall rounded ${currentImage === "/pimgHD/" + props.pid + "/" + props.data.container_photo_id + ".webp" ? 'Selected' : ''}`} />
                                {
                                    props.data.extra_container_photo_ids.map((i, index) => {
                                        if (index < 30) {
                                            return (
                                                <img
                                                    src={`/pimgHD/` + props.pid + "/" + i + ".webp"}
                                                    alt="Container product image."
                                                    onClick={() => { setCurrentImage("/pimgHD/" + props.pid + "/" + i + ".webp"); setBGPos({ ...bgPos, backgroundImage: `url(${"/pimgHD/" + props.pid + "/" + i + ".webp"})` }) }}
                                                    className={`rounded pointer ${currentImage === "/pimgHD/" + props.pid + "/" + i + ".webp" ? 'Selected' : ''}`}
                                                    key={index}
                                                />
                                            )
                                        } else {
                                            return null;
                                        }
                                    })
                                }
                            </div>
                        </div>
                        <div className='desktop w-100'>
                            <div className="d-flex space-between ProductImagePreviews scrollbar ">
                                <img src={`/pimgHD/` + props.pid + "/" + props.data.container_photo_id + ".webp"} onClick={() => {
                                    setCurrentImage("/pimgHD/" + props.pid + "/" + props.data.container_photo_id + ".webp");
                                    setBGPos({ ...bgPos, backgroundImage: `url(${"/pimgHD/" + props.pid + "/" + props.data.container_photo_id + ".webp"})` });
                                }} alt="Container product image." className={`pointer ProductImageSmall rounded ${currentImage === "/pimgHD/" + props.pid + "/" + props.data.container_photo_id + ".webp" ? 'Selected' : ''}`} />
                                {
                                    props.data.extra_container_photo_ids.map((i, index) => {
                                        if (index < 30) {
                                            return (
                                                <img
                                                    src={`/pimgHD/` + props.pid + "/" + i + ".webp"}
                                                    alt="Container product image."
                                                    onClick={() => { setCurrentImage("/pimgHD/" + props.pid + "/" + i + ".webp"); setBGPos({ ...bgPos, backgroundImage: `url(${"/pimgHD/" + props.pid + "/" + i + ".webp"})` }) }}
                                                    className={`rounded pointer ${currentImage === "/pimgHD/" + props.pid + "/" + i + ".webp" ? 'Selected' : ''}`}
                                                    key={index}
                                                />
                                            )
                                        } else {
                                            return null;
                                        }
                                    })
                                }
                            </div>
                        </div>
                        <br /><br />
                        <div className="desktop">
                            {
                                ["gp", "hc", "hh"].includes(props.data.container_height) && [40, 20, 10].includes(props.data.container_length) &&
                                <Dimensions height={props.data.container_height} length={props.data.container_length} />
                            }
                        </div>
                    </div>
                    <div className="flex-025"></div>
                    <div className="flex-9 text-left">
                        <div className="w-90 ProductDetails rounded bg-light shadow center">
                            <div className="w-90">
                                <h1 className="color-main mt-2 h2-style">{props.data.container_iso_description}</h1>
                                <h3 className='no-block-start'>${numberWithCommas(props.data.price_inc.toFixed(2))} inc.</h3>
                                <p>{props.data.container_short_description ? props.data.container_short_description : ""}</p>
                                <ul>
                                    {
                                        props.data.sale_points.map((feature, index) => {
                                            if (feature.type === 1) {
                                                return <li className='hlcrown' key={index}>{feature.text}</li>;
                                            }
                                            else {
                                                return <li className='crown' key={index}>{feature.text}</li>;
                                            }
                                        })
                                    }
                                </ul>
                                <p>{props.data.container_long_description ? props.data.container_long_description : ""}</p>
                                <p>For more information about this container, please don't hesitate to email us on <a href={`mailto:service@${config.email_domain}`}>{`service@${config.email_domain}`}</a> or call us on <a href={"tel:" + config.tel}>{config.tel_text}</a>. For information on how we rank shipping containers, please read our article about <a className='underline' href={`https://www.abcchs.com.au/grading`}>Shipping Container Grading</a>.</p>
                                <div className='w-100 d-flex'>
                                    {
                                        isInCart ?
                                            <div className="Button text-center w-200px grayscale" onClick={() => removeFromCart(props.pid)}>Remove From Cart</div>
                                            :
                                            <div className="Button text-center w-200px" onClick={() => addToCart({ ...props.data, pid: props.pid })}>Add To Cart</div>
                                    }
                                </div>
                                <br />
                                <div className="small-text">
                                    <b>Container Number: </b> {props.data.container_number}<br />
                                </div>
                                <br />
                            </div>
                        </div>
                        <br /><br />
                        {
                            productLat &&
                            <div className='w-90'>
                                {/* {getLocationLink(locationName)}<br /><br /> */}
                                <Map lat={productLat} lng={productLng} className="shadow" />
                            </div>
                        }
                        <br /><br />
                        <div className="mobile">
                            {
                                ["gp", "hc", "hh"].includes(props.data.container_height) && [40, 20, 10].includes(props.data.container_length) &&
                                <Dimensions height={props.data.container_height} length={props.data.container_length} />
                            }
                            <br /><br />
                        </div>
                        <h3 className='w-90'>Similar Products:</h3>
                        {
                            (props.similarProducts.containers.slice(0, 8) !== "Loading..." && props.similarProducts.containers.slice(0, 8) !== false) ?
                                <div>
                                    <div className='w-90 mt-2 mb-4 ProductContainer'>
                                        {
                                            props.similarProducts.containers.slice(0, 8).map((product, index) => 
                                                {
                                                    const inCart = cart.map(a => {return a.container_id}).includes(product.container_id);

                                                    let priority = "auto";
                                                    if(index === 0) priority = "high";
                                                    return (
                                                        <SmallCard priority={priority} cart={cart} inCart={inCart} key={index} price={product.price_inc} price_ex={product.price_ex} pid={product.container_id} location={product.container_location_name} img={`/pimgV2/${product.container_id}/${product.container_photo_id}.webp`} title={product.container_iso_description}>
                                                            <h4>{product.container_number}</h4>
                                                            {product.container_description}
                                                        </SmallCard>
                                                    )
                                                }

                                                // <a href={`/product/${product.container_id}`} key={index}>
                                                //     <div className='ProductSuggestion rounded shadow bg-light'>
                                                //         <img src={`/pimg/${product.container_id}/${product.container_photo_id}.webp`} alt={product.container_iso_description} />
                                                //         <div className="text">
                                                //             <div className="color-purple no-block-start no-block-end">${numberWithCommas(product.price_inc.toFixed(2))} inc. <div className="color-dark small-text">Rank {product.container_grade_id}/10</div></div> <br />
                                                //             {product.container_iso_description}
                                                //         </div>
                                                //     </div>
                                                // </a>
                                            )
                                        }
                                    </div>
                                </div>
                                :
                                props.similarProducts.containers === "Loading..." ?
                                    <div className="w-100 d-flex justify-center screen-spacer">
                                        <Loading />
                                    </div>
                                    :
                                    ""
                        }
                    </div>
                </div>
                }
            </div>
            {
                !props.productSuccess &&
                <div className='w-100 text-center'>
                    <Helmet>
                        <meta
                            name="description"
                            content={"We weren't able to find your product. Please search for a different one."}
                        />
                        <title>Browse Other Products</title>
                        <link rel="canonical" href={`https://${config.domain}/shipping-container/${props.location}/${props.data.container_id}`} />
                    </Helmet>
                    <h3>We weren't able to find information for the product you're looking for.</h3>
                    <p>
                        {
                            (typeof props.similarProducts != "object") ?
                                "Use the search feature below to find other products you may be interested in."
                                :
                                "The container that you're looking for is not available anymore. Here is a list of similar products:"
                        }
                    </p><br />
                    <div className="w-70 d-flex justify-center">
                        {
                            (typeof props.similarProducts != "object") &&
                            <Search />
                        }
                    </div>
                    <br /><br />
                    {
                        (typeof props.similarProducts == "object") ?
                            <div>
                                <div className='ProductContainer'>
                                    {
                                        props.similarProducts.containers.map((product, index) => 
                                            {
                                                const inCart = cart.map(a => {return a.container_id}).includes(product.container_id);

                                                let priority = "auto";
                                                if(index === 0) priority = "high";
                                                return (
                                                    <SmallCard priority={priority} cart={cart} inCart={inCart} key={index} price={product.price_inc} price_ex={product.price_ex} pid={product.container_id} location={product.container_location_name} img={`/pimgV2/${product.container_id}/${product.container_photo_id}.webp`} title={product.container_iso_description}>
                                                        <h4>{product.container_number}</h4>
                                                        {product.container_description}
                                                    </SmallCard>
                                                )
                                            }

                                            // <a href={`/product/${product.container_id}`}>
                                            //     <div className='ProductSuggestion rounded shadow bg-light'>
                                            //         <img src={`/pimg/${product.container_id}/${product.container_photo_id}.webp`} alt={product.container_iso_description} />
                                            //         <div className="text">
                                            //             <div className="color-purple no-block-start no-block-end">${numberWithCommas(product.price_inc.toFixed(2))} inc. <div className="color-dark small-text">Rank {product.container_grade_id}/10</div></div> <br />
                                            //             {product.container_iso_description}
                                            //         </div>
                                            //     </div>
                                            // </a>
                                        )
                                    }
                                </div>
                            </div>
                            :
                            (typeof props.similarProducts != "object") === "Loading..." ?
                                <div className="w-100 d-flex justify-center">
                                    <Loading />
                                </div>
                                :
                                ""
                    }
                </div>
            }
        </div>
    );
};

export default Product;